export const TRIAL_DAYS = 30 as const;
